import { Menu } from "@mui/icons-material"
import { IconButton, Stack, Typography } from "@mui/material"

import Button from "@components/button"
import PageHeader from "@components/page_header"
import { PRIMARY } from "@constants/colors"

import CreateCoupon from "@components/dialogs/create_coupon"
import { useCouponsPageContext } from "@contexts/main/coupons_page_context"
import { useState } from "react"
import styles from "./styles"

export default function CouponsPageHeader() {
  const { translate, isLeftDrawerOpen, toggleIsLeftDrawerOpen } =
    useCouponsPageContext()

  const [open, setOpen] = useState(false)

  return (
    <PageHeader sx={styles.content} isLeftPanelOpen={isLeftDrawerOpen}>
      <Stack direction={"row"} alignItems={"center"} columnGap={1}>
        <IconButton
          onClick={toggleIsLeftDrawerOpen}
          disabled={!!isLeftDrawerOpen}
          disableRipple
          sx={{
            display: !!isLeftDrawerOpen ? "none" : "block",
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <Menu />
        </IconButton>

        <Typography variant="h6">{translate("coupons_tooltip")}</Typography>
      </Stack>
      <Stack
        direction={"row"}
        gap={1}
        sx={{
          position: "absolute",
          right: isLeftDrawerOpen ? "calc(50px + 1rem)" : "1rem",
          transition: "right 0.3s ease-in-out"
        }}
      >
        <Button sx={{ width: "13rem" }} onClick={() => setOpen(true)}>
          {translate("new_coupon")}
        </Button>
      </Stack>
      <CreateCoupon isOpen={open} setClose={() => setOpen(false)} />
    </PageHeader>
  )
}
